import React, { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import MovingDivs from "../accueil/mouvDiv";
import CookieConsent from "../accueil/cookiesConsent";
import { Header } from "../common/nav";

type AppLayoutProps = {
  children: ReactNode;
};

const CookieConsentLayer = CookieConsent as unknown as React.ComponentType;

const AppLayout = ({ children }: AppLayoutProps) => {
  const location = useLocation();
  const isAllArtworksPage = location.pathname === "/oeuvres" || location.pathname.startsWith("/oeuvres/");
  const showMarquee = !isAllArtworksPage;

  return (
    <div className={`app-layout ${isAllArtworksPage ? "app-layout--without-marquee" : ""}`}>
      <div className="texture-grain" aria-hidden="true" />
      <header className="app-layout__topbar">
        <Link to="/" className="app-layout__logo focus-ring" aria-label="Retour a l'accueil">
          <span className="app-layout__logo-icon" aria-hidden="true">
            <img src="/images/logo/newLogo.png" alt="" />
          </span>
          <span className="app-layout__logo-text">NAAT</span>
        </Link>
   
      </header>

      <main className="app-layout__main">
        <Header />
        <div className="app-layout__content">{children}</div>
      </main>

      <CookieConsentLayer />
    </div>
  );
};

export default AppLayout;
